import classes from "./WhatPeopleSay.module.css";
import Slider from "react-slick";
// Import css files
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CLIENT_REVIEWS } from "../../../constants";

const WhatPeopleSay = () => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: "60px",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
    ],
  };

  return (
    <div className={`mt-bg ${classes.parent}`}>
      <h2 className="subtitle center mt-md mb-sm">What people say about us</h2>
      <p className="mb-md center">
        Hear from people who have had an amazing experience with us
      </p>
      <div className={`${classes.sliderMain}`}>
        <Slider {...settings}>
          {CLIENT_REVIEWS.map((item, i) => (
            <div key={`review-${i}`} className={classes.reviewMain}>
              <div className={classes.review}>
                <p className="mb-md">{item.message}</p>
                <div className={`flex`}>
                  <img src={item.image} alt="" />
                  <p>{item.name}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default WhatPeopleSay;
